// Arrow keys OL's KeyboardPan interaction reacts to (see ol/interaction/KeyboardPan).
const PAN_KEYS = new Set(['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight']);

// Elements where an arrow keypress edits text/selection rather than panning
// the map, mirroring OL's own `targetNotEditable` condition. KeyboardPan
// itself ignores arrow keys typed into these, so our "did the user move the
// map" tracking must too.
const EDITABLE_TAGS = new Set(['INPUT', 'SELECT', 'TEXTAREA']);

/**
 * Whether a keydown event corresponds to OL's KeyboardPan interaction
 * actually panning the map (i.e. it should be treated as the user having
 * moved the map themselves).
 *
 * Mirrors KeyboardPan's default condition (noModifierKeys && targetNotEditable,
 * see ol/interaction/KeyboardPan + ol/events/condition): a modifier key held
 * down (Alt/Ctrl/Meta/Shift) makes OL ignore the arrow key entirely — e.g.
 * Ctrl+ArrowLeft / Cmd+ArrowLeft are common OS/browser text-navigation
 * shortcuts, not map panning — so without this guard those keypresses would
 * be wrongly treated as the user having moved the map.
 */
export const isKeyboardPanEvent = event =>
	PAN_KEYS.has(event.key) &&
	!event.altKey &&
	!event.ctrlKey &&
	!event.metaKey &&
	!event.shiftKey &&
	!EDITABLE_TAGS.has(event.target?.tagName) &&
	!event.target?.isContentEditable;
